import React, { Suspense, useLayoutEffect } from "react";
import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import AuthorisedLayout from "../layout/AuthorizedLayoutComponent";
import LazyLoad from "../../LazyLoad";
import { Loader } from "../Shared/PageLoader";
import { useSelector } from "react-redux";
import { useIsAllowedAllPermissionsForSomeRoles, useGetCodeWiseAppModuleFeaturePermission } from "../../helper/sessionHelper";


const IOMComponent = LazyLoad("./components/pages/Inter Office Memo (IOM)/IOMComponent");
const NewIOMComponent = LazyLoad("./components/pages/Inter Office Memo (IOM)/NewIOMComponent");
const IOMViewComponent = LazyLoad("./components/pages/Inter Office Memo (IOM)/IOMViewComponent");
const IOMConfigurationComponent = LazyLoad("./components/pages/Inter Office Memo (IOM)/IOMConfigurationComponent");
const PendingIOMComponent = LazyLoad("./components/pages/Inter Office Memo (IOM)/PendingIOMComponent");
const Test = LazyLoad("./components/pages/Inter Office Memo (IOM)/Test");
const IOMv2Component = LazyLoad("./components/pages/Inter Office Memo (IOM)/IOMv2Component");
const IOMRecallRequestsComponent = LazyLoad("./components/pages/Inter Office Memo (IOM)/IOMRecallRequestsComponent");

const CategoryComponent = LazyLoad("./components/pages/Category/CategoryComponent");

const NewIOMComponentV2 = LazyLoad("./components/pages/Inter Office Memo (IOM)/NewIOMComponentV2");

const FundRequestComponent = LazyLoad("./components/pages/FundRequest/FundRequestComponent");
const AddEditFundRequestComponent = LazyLoad("./components/pages/FundRequest/AddEditFundRequestComponent");
const ViewFundRequestComponent = LazyLoad("./components/pages/FundRequest/ViewFundRequestComponent");
const ViewFundRequestComponent_V2 = LazyLoad("./components/pages/FundRequest/ViewFundRequestComponent_V2");
const ApprovedFundRequestComponent = LazyLoad("./components/pages/FundRequest/ApprovedFundRequestComponent");

const MyTaskComponent = LazyLoad("./components/pages/MyTask/MyTaskComponent");

const PaymentRequestComponent = LazyLoad("./components/pages/PaymentRequest/PaymentRequestComponent");
const ViewPaymentRequestComponent = LazyLoad("./components/pages/PaymentRequest/ViewPaymentRequestComponent");
const AddEditPaymentReqestComponent = LazyLoad("./components/pages/PaymentRequest/AddEditPaymentReqestComponent");

const IOMReportComponent = LazyLoad("./components/pages/IOMReport/IOMReport");
const FundRequestReportComponent = LazyLoad("./components/pages/FundRequestReport/FundRequestReport");
const PaymentRequestReportComponent = LazyLoad("./components/pages/PaymentRequestReport/PaymentRequestReport");


const DashboardComponent = LazyLoad("./components/dashboard/DashboardComponent");
const CompanyComponent = LazyLoad("./components/pages/Company/CompanyComponent.js");
const LoginPage = LazyLoad("./components/LoginPage");
//const StateComponent = LazyLoad("./components/pages/State");

function AppRoutes() {
    const user = useSelector((state) => state.user.data);
    const isAuthorized = user?.authorized === true;

    const ProtectedRoute = ({ featureCode, permissionTypes, element }) => {
        let accessKeys = { view: "canView", add: "canAdd", edit: "canEdit", delete: "canDelete", export: "canExport", approve: "canApprove", reject: "canReject" }

        const isAllowedForThisRole = useIsAllowedAllPermissionsForSomeRoles();
        const featurePermission = useGetCodeWiseAppModuleFeaturePermission(featureCode);    // here featureCode is actually applicationModuleFeature.code
        let isPermitted = (permissionTypes === true) ? true : permissionTypes?.some((item) => featurePermission?.[accessKeys?.[item]]);

        return (isAllowedForThisRole || isPermitted)
            ? React.cloneElement(element, { isAllowedForThisRole, featurePermission })
            : <div>You do not have access to this page.</div>;
    };

    useLayoutEffect(() => {
        // 🔴 Do nothing if not iframe
     

         if (!user?.isIframe) return;
        // if (!user?.checkIsIframe) return;
        const pageTitle = document.querySelector("#pageTitle");
        if (pageTitle) pageTitle.innerHTML = "Dashboard";
        const topbarCompany = document.querySelector(".top-bar-company");
        const sidebar = document.querySelector(".main-sidebar");
        const header = document.querySelector(".main-header");
        const contentWrapper = document.querySelector(".content-wrapper");

        const isMobile = window.matchMedia("(max-width: 768px)").matches;

        if (topbarCompany) topbarCompany.style.display = "none";
        if (sidebar) sidebar.style.display = "none";
        if (header) header.style.display = "none";
        if (contentWrapper) {
            contentWrapper.style.marginLeft = isMobile ? "0px" : "0px"; // still 0 in both, you can update for other conditions if needed
        }

        return () => {
            if (topbarCompany) topbarCompany.style.display = "flex";
            if (sidebar) sidebar.style.display = "block";
            if (header) header.style.display = "flex";
            if (contentWrapper) {
                contentWrapper.style.marginLeft = isMobile ? "0px" : "250px";
            }
        };
    }, [user]);

    return (
        <Suspense fallback={<Loader />}>
            {isAuthorized === true ? (
                <AuthorisedLayout>
                    <Routes>
                        <Route path="/" element={<AuthorizedRouteWrapper />}>

                            <Route path="*" element={<ProtectedRoute featureCode={"VAULTZ-MYTASK"} permissionTypes={["view"]} element={<MyTaskComponent />} />} />
                            <Route path="/" element={<ProtectedRoute featureCode={"VAULTZ-MYTASK"} permissionTypes={["view"]} element={<Navigate to="/pending-tasks" replace />} />} />
                            {/* <Route path="/pending-ioms" element={<ProtectedRoute featureCode={"064e751e-7c70-48cf-9442-9a50d55d899c"} permissionTypes={["view"]} element={<PendingIOMComponent />} />} /> */}
                            <Route path="/pending-tasks" element={<ProtectedRoute featureCode={"VAULTZ-MYTASK"} permissionTypes={["view"]} element={<MyTaskComponent />} />} />

                            <Route path="/dashboard" element={<ProtectedRoute featureCode={"bf5fa860-db41-4fb3-9bbd-304ddbcc518d"} permissionTypes={["view"]} element={<DashboardComponent />} />} />
                            {/* <Route path="/inter-office-memo" element={<ProtectedRoute featureCode={"____"} permissionTypes={["view"]} element={<IOMComponent />} />} /> */}
                            <Route path="/inter-office-memo-old" element={<ProtectedRoute featureCode={"DG_DM_IOMOLD"} permissionTypes={["view"]} element={<IOMComponent />} />} />
                            <Route path="/inter-office-memo" element={<ProtectedRoute featureCode={"eee9f4eb-a04f-49e9-87ac-4b916b61ce31"} permissionTypes={["view"]} element={<IOMv2Component />} />} />
                            <Route path="/new-inter-office-memo-old" element={<ProtectedRoute featureCode={"eee9f4eb-a04f-49e9-87ac-4b916b61ce31"} permissionTypes={["add", "edit"]} element={<NewIOMComponent />} />} />
                            <Route path="/new-inter-office-memo" element={<ProtectedRoute featureCode={"eee9f4eb-a04f-49e9-87ac-4b916b61ce31"} permissionTypes={["add", "edit"]} element={<NewIOMComponentV2 />} />} />
                            <Route path="/iom-preview" element={<ProtectedRoute featureCode={"eee9f4eb-a04f-49e9-87ac-4b916b61ce31"} permissionTypes={true} element={<IOMViewComponent />} />} />
                            <Route path="/inter-office-memo-configuration" element={<ProtectedRoute featureCode={"a8727d04-0177-4641-a42b-af800c2da1a7"} permissionTypes={["view"]} element={<IOMConfigurationComponent />} />} />
                            <Route path="/TESTT" element={<ProtectedRoute featureCode={"____"} permissionTypes={true} element={<Test />} />} />
                            <Route path="/recall-requests" element={<ProtectedRoute featureCode={"eee9f4eb-a04f-49e9-87ac-4b916b61ce32"} permissionTypes={true} element={<IOMRecallRequestsComponent />} />} />
                            <Route path="/category" element={<ProtectedRoute featureCode={"CATEGORY-0C1"} permissionTypes={true} element={<CategoryComponent />} />} />
                            <Route path="/fundrequest" element={<ProtectedRoute featureCode={"VS_FUND_REQUEST"} permissionTypes={true} element={<FundRequestComponent />} />} />
                            <Route path="/approved-fundrequest" element={<ProtectedRoute featureCode={"VS_APPROVED_FUND_REQUEST"} permissionTypes={true} element={<ApprovedFundRequestComponent />} />} />
                            <Route path="/new-fund-request" element={<ProtectedRoute featureCode={"VS_FUND_REQUEST"} permissionTypes={true} element={<AddEditFundRequestComponent />} />} />
                            <Route path="/view-fund-request" element={<ProtectedRoute featureCode={"VS_VIEW_FUND_REQUEST"} permissionTypes={true} element={<ViewFundRequestComponent_V2 />} />} />
                            <Route path="/payment-request" element={<ProtectedRoute featureCode={"VS_PAYMENT_REQUEST"} permissionTypes={true} element={<PaymentRequestComponent />} />} />
                            <Route path="/view-payment-request" element={<ProtectedRoute featureCode={"VS_VIEW_PAYMENT_REQUEST"} permissionTypes={true} element={<ViewPaymentRequestComponent />} />} />
                            <Route path="/iom-report" element={<ProtectedRoute featureCode={"VS_IOM_REPORT"} permissionTypes={true} element={<IOMReportComponent />} />} />
                            <Route path="/fundrequest-report" element={<ProtectedRoute featureCode={"VS_FUND_REQUEST_REPORT"} permissionTypes={true} element={<FundRequestReportComponent />} />} />
                            <Route path="/payment-request-report" element={<ProtectedRoute featureCode={"VS_PAYMENT_REQUEST_REPORT"} permissionTypes={true} element={<PaymentRequestReportComponent />} />} />
                            <Route path="/add-edit-payment-request" element={<ProtectedRoute featureCode={"VS_PAYMENT_REQUEST"} permissionTypes={true} element={<AddEditPaymentReqestComponent />} />} />
                        </Route>
                    </Routes>
                </AuthorisedLayout>
            ) : (
                <Routes>
                    <Route path="/" element={<LoginPage />} />
                    <Route path="*" element={<LoginPage />} />
                    <Route path="/login" element={<LoginPage />} />
                </Routes>
            )}
        </Suspense>
    );
}
export default AppRoutes;

function AuthorizedRouteWrapper() {
    return (
        <>
            <Suspense fallback={<Loader />}>
                <Outlet />
            </Suspense>
        </>
    );
}
function RanderDashboard() {
    let dashboard = <DashboardComponent />;
    return dashboard;
}